import { useTranslation } from 'react-i18next';
import PageLayout from '@app/components/PageLayout';
import Borrower from '@modules/borrower/components/Borrower';
const BorrowerStart = () => {
    const { t } = useTranslation();
    return (<PageLayout title={t('financing.borrowing_page.borrowing')}>
            <Borrower />
        </PageLayout>);
};
export default BorrowerStart;
